export const addInitialValues = {
  productName: '',
};
